import React from 'react';
import styles from './styles.less';
import { Nav } from 'react-bootstrap';
import { LegendBody } from './legend-body';


//{length: int, <int>: {componentType:str, name: str}} * ('point' | 'edge') * str -> bool
function hasColumn(columns = [], kind, name) {
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        if (column && (column.componentType === kind) && (column.name === name)) {
            return true;
        }
    }
    return false;
}``

export const Legend = ({
    columns = [],
    typeHistogram,
    visible,
    pivotHistogram,
    encodings,
    activeTab,
    onTabSelected
}) => {

    const hasTypesTab = hasColumn(columns, 'point', 'type');
    const hasPivotsTab = hasColumn(columns, 'point', 'Pivot') && hasColumn(columns, 'edge', 'Pivot');

    const pointIconEncodingAttribute =
        (encodings && encodings.point && encodings.point.icon && encodings.point.icon.attribute) ||
        '';
    const pointSizeEncodingAttribute =
        (encodings && encodings.point && encodings.point.size && encodings.point.size.attribute) ||
        '';
    const pointColorEncodingAttribute =
        (encodings &&
            encodings.point &&
            encodings.point.color &&
            encodings.point.color.attribute) ||
        '';

    const pointColor = encodings && encodings.point && encodings.point.color;
    const pointSize = encodings && encodings.point && encodings.point.size;
    const pointIcon = encodings && encodings.point && encodings.point.icon;

    const canonicalTypeAttribute = 'type';
    const pivotAttribute = 'Pivot'; // maybe pull these from the histogram model?
    const typeBins =
        typeHistogram && typeHistogram.global && typeHistogram.global.bins
            ? typeHistogram.global.bins
            : null;
    const pivotBins =
        pivotHistogram && pivotHistogram.global && pivotHistogram.global.bins
            ? pivotHistogram.global.bins
            : null;
    const typeKey = [
        pointIconEncodingAttribute === canonicalTypeAttribute,
        pointSizeEncodingAttribute === canonicalTypeAttribute,
        pointColorEncodingAttribute === canonicalTypeAttribute
    ];
    const pivotKey = [
        pointIconEncodingAttribute === pivotAttribute,
        pointSizeEncodingAttribute === pivotAttribute,
        pointColorEncodingAttribute === pivotAttribute
    ];

    const legendBodyProps =
        activeTab === 'legendPivotTab' && pivotBins !== null
            ? {
                  name: 'Pivot',
                  bins: pivotBins,
                  data: pivotHistogram,
                  iconEncodings: pointIcon,
                  iconsOn: pivotKey[0],
                  sizeEncodings: pointSize,
                  sizesOn: pivotKey[1],
                  colorEncodings: pointColor,
                  colorsOn: pivotKey[2]
              }
            : {
                  name: 'Type',
                  bins: typeBins,
                  data: typeHistogram,
                  iconEncodings: pointIcon,
                  iconsOn: typeKey[0],
                  sizeEncodings: pointSize,
                  sizesOn: typeKey[1],
                  colorEncodings: pointColor,
                  colorsOn: typeKey[2]
              };
    return !visible ? null : (
        <div className={styles['legendContainer']}>
            <Nav
                variant="tabs"
                className={styles['legendHeader']}
                onSelect={onTabSelected}
                activeKey={activeTab}>
                <Nav.Item disabled={true}>
                    <Nav.Link disabled>Legend</Nav.Link>
                </Nav.Item>
                { hasTypesTab
                    ? <Nav.Item>
                        <Nav.Link eventKey="legendTypeTab">Type</Nav.Link>
                    </Nav.Item>
                    : null }
                { hasPivotsTab && pivotBins !== null
                    ? <Nav.Item disabled={pivotBins === null}>
                        <Nav.Link eventKey="legendPivotTab" >Pivot</Nav.Link>
                    </Nav.Item>
                    : null }
            </Nav>
            <LegendBody {...legendBodyProps} key="legend-body" />
            <LegendFooter {...legendBodyProps} key="legend-footer" />
        </div>
    );
};

function LegendFooter({
    bins,
    iconEncodings,
    iconsOn,
    colorEncodings,
    colorsOn,
    sizeEncodings,
    sizesOn
}) {
    return (
        <div className={styles['legendFooter']}>
            {iconEncodings && !iconsOn
                ? toRow('Icons', iconEncodings.attribute, 'icons')
                : undefined}
            {colorEncodings && !colorsOn
                ? toRow('Colors', colorEncodings.attribute, 'colors')
                : !colorEncodings ? toRow('Colors', <i>cluster</i>, 'colors') : undefined}
            {sizeEncodings && !sizesOn
                ? toRow('Sizes', sizeEncodings.attribute, 'sizes')
                : !sizeEncodings ? toRow('Sizes', 'degree', 'sizes') : undefined}
        </div>
    );
}

function toRow(name, attr, key) {
    return (
        <div key={key} className={styles['encodingRow']}>
            <span className={styles['encodingType']}>{name}</span>
            <span className={styles['encodingSpacer']} />
            <span className={styles['encodingAttr']}>{attr}</span>
        </div>
    );
}
